<!--
 * @Author: wjw
 * @Github: https://github.com/wangjiawei2019
 * @Date: 2019-06-20 18:10:14
 * @LastEditors: linfangxing@jinlingkeji.cn linfangxing@jinlingkeji.cn
 * @LastEditTime: 2024-03-15 09:44:12
 -->
<template>
  <div class="newsframe">
    <div>
      <div class="navlefttitle">{{ pageTitle }}</div>
      <ul class="newslist" v-if="newsmenu.length">
        <li
          v-for="item in newsmenu"
          :key="item.id"
          :class="{ _activeli: pathTwo == item.id }"
          @click="handleMenuClick(item.id, item.name)"
        >
          {{ item.name }}
        </li>
        <li
          v-if="pathOne == 'information_open'"
          @click="handleMenuClick(-1, '谏言献策')"
          :class="{ _activeli: pathTwo == -1 }"
        >
          谏言献策
        </li>
      </ul>
    </div>
    <div class="newscontent" v-if="!specialPage">
      <div>
        <nav>
          <span>{{ contentTitle }}</span>
        </nav>
        <ul>
          <li
            v-for="item in searchRes.list"
            :key="item.id"
            @click="handleGoContent(item.id, item.live_url)"
          >
            <div class="lesson-icon" v-if="contentTitle == '网络课程'"></div>
            <span class="item-title">{{ item.title }}</span>
            <span class="item-createtime">{{ item.createtime }}</span>
          </li>
        </ul>
      </div>
      <div class="search-footer">
        <el-pagination
          background
          layout="pager, next"
          :current-page="searchRes.start_page"
          :total="searchRes.count"
          @current-change="currentPageClick"
        ></el-pagination>
      </div>
    </div>
    <!-- 疫情防控专题 -->
    <Epidemic
      :specialPage="specialPage"
      v-if="specialPage === 'epidemic'"
      key="epidemic"
    ></Epidemic>
    <!-- 谏言献策 -->
    <div class="adviceContent" v-if="specialPage === 'advice'">
      <header>
        谏言献策
        <div></div>
      </header>
      <div class="form-box">
        <div class="inp-box">
          <div class="inp-title">姓名</div>
          <div class="inp-wrapper">
            <input
              type="text"
              placeholder="请输入姓名"
              v-model="formData.name"
            />
          </div>
        </div>
        <div class="inp-box">
          <div class="inp-title">电子邮件</div>
          <div class="inp-wrapper">
            <input
              type="email"
              placeholder="请输入电子邮件"
              v-model="formData.email"
            />
          </div>
        </div>
        <div class="inp-box">
          <div class="inp-title">手机号/电话</div>
          <div class="inp-wrapper">
            <input
              type="number"
              placeholder="请输入手机号/电话"
              v-model="formData.mobile"
            />
          </div>
        </div>
        <div class="textarea-box">
          <div class="textarea-title">通信地址</div>
          <div class="textarea-wrapper">
            <textarea
              class="textarea1"
              placeholder="请输入通信地址"
              v-model="formData.address"
              autoHeight="true"
              maxlength="50"
              @focus="focus(0)"
              @blur="focus(null)"
            ></textarea>
            <div class="astrict-desc" v-if="aim === 0">
              {{ this.formData.address.length }}/50
            </div>
          </div>
        </div>
        <div class="inp-box">
          <div class="inp-title">单位</div>
          <div class="inp-wrapper">
            <input
              type="text"
              placeholder="请输入单位"
              v-model="formData.employers"
            />
          </div>
        </div>
        <div class="inp-box">
          <div class="inp-title">主题</div>
          <div class="inp-wrapper">
            <input
              type="text"
              placeholder="请输入主题"
              v-model="formData.topic"
            />
          </div>
        </div>
        <div class="textarea-box">
          <div class="textarea-title">内容</div>
          <div class="textarea-wrapper">
            <textarea
              class="textarea2"
              placeholder="请输入内容"
              v-model="formData.content"
              autoHeight="true"
              maxlength="200"
              @focus="focus(1)"
              @blur="focus(null)"
            ></textarea>
            <div class="astrict-desc" v-if="aim === 1">
              {{ this.formData.content.length }}/200
            </div>
          </div>
        </div>
        <div class="inp-box">
          <div class="inp-title">验证码</div>
          <div class="inp-wrapper code-box">
            <input
              type="text"
              placeholder="请输入验证码"
              v-model="formData.code"
            />
          </div>
          <div class="img-wrapper">
            <img :src="imgSrc" alt />
          </div>
          <div class="font-wrapper" @click="handleRefreshCode">
            <u>看不清，换一张</u>
          </div>
        </div>
        <footer @click="handleSubmit" class="btn">提交</footer>
      </div>
    </div>
    <!-- 智慧校园 -->
    <div
      class="school"
      v-if="specialPage === 'school' && pathOne === 'online_service'"
    >
      <header>数字化校园认证</header>
      <section>
        &emsp;&emsp;随着5G时代的到来，教育信息化、数字化是一种趋势。中国老年大学协会走在时代前端，与金龄科技达成战略合作，携手华为，在5G技术支持下，加快人工智能、大数据、物联网和各类智能设备及网络在基础教育领域的落地，积极开展智慧教育创新研究和示范，推动基础教育的模式变革和生态重构。
      </section>
      <div class="form-box">
        <a :href="downLoadUrl">
          <div>
            <div></div>
            <div>{{ downLoadName }}.doc</div>
          </div>
          <div>
            <div></div>
            <div>下载</div>
          </div>
        </a>
        <span
          >*请下载表格进行认证申请，并盖公章上传扫描件，如有疑问，请微信扫码添加【认证助手】，一对一专业指导</span
        >
      </div>
      <footer>
        <el-upload
          class="avatar-uploader"
          action
          name="file4"
          :show-file-list="false"
          :http-request="upload4"
        >
          <div class="upload-btn">{{ uploadDesc }}</div>
        </el-upload>
      </footer>
      <div class="school-code-box">
        <div></div>
        <div>
          扫码添加
          <span>认证助手</span>
        </div>
        <div>一对一专业指导</div>
      </div>
    </div>
    <!-- 智慧管理系统申请 -->
    <div class="register" v-if="specialPage === 'register'">
      <header>智慧管理系统申请</header>
      <div>
        &emsp;&emsp;目前，大多数老年大学都是采取现场报名的方式，等待时间长，程序复杂。每至报名日，各老年大学报名大厅被挤得水泄不通，甚至有老年人凌晨开始排队，只为报上自己心仪的课程。对于老年人而言，这样既不方便，也存在一定的安全隐患。
      </div>
      <div>
        &emsp;&emsp;为了解决这个难题，中国老年大学协会和金龄科技达成战略合作，携手华为，研发线上报名系统，
        <span>提供给全国老年大学使用。</span
        >有了它，老年人只需在手机上就可以完成注册、登录、选课、缴费，足不出户就能完成整个报名流程。不会操作电脑或上网的老年人，也可以由子女或亲戚朋友代为报名。学员再也不用带着马扎、小板凳凌晨两三点钟到学校排队了。
      </div>
      <footer @click="toggleRegisterCode()">马上申请</footer>
    </div>
    <!-- 智慧助老 -->
    <Epidemic
      :specialPage="specialPage"
      v-if="specialPage === 'wisdom'"
      key="wisdom"
    ></Epidemic>
  </div>
</template>

<script>
import Epidemic from "@/components/special_report/epidemic";
import store from "@/store/index";
import Api from "@/api/commonApi";
import Filter from "@/util/filter";
import axios from "axios";

export default {
  components: {
    Epidemic,
  },
  data() {
    return {
      newsmenu: [],
      searchRes: {
        count: null,
        list: [],
        start_page: null,
        total_page: null,
      },
      authCode: null,
      formData: {
        name: "",
        mobile: "",
        address: "",
        email: "",
        topic: "",
        content: "",
        employers: "",
        code: "",
      },
      aim: null,
      uploadDesc: "上传",
      downLoadUrl: "", // 5G智慧校园下载链接
      downLoadName: "", // 5G智慧校园文件名称
    };
  },
  methods: {
    getMenuLeftList(current1) {
      Api.getLeftList(current1)
        .then((res) => {
          // 获取左边列表
          this.newsmenu = res.data;
          if (this.contentTitle === "谏言献策") {
            return null;
          } else if (this.contentTitle == "网络课程") {
            this.showInternetList(1);
          } else {
            this.showlist(this.pathTwo, 1);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    showlist(type, start_page = 1) {
      // 如果是在线服务  特殊处理
      if (this.pathOne == "online_service") {
        // 会员申请
        if (type == 1) {
        }
        // 会员登录
        if (type == 3) {
        }
        // 表格下载
        if (type == 2) {
          Api.getFormList(start_page)
            .then((res) => {
              const { count, list, start_page, total_page } = res.data;
              this.searchRes.count = count;
              this.searchRes.list = list;
              this.searchRes.start_page = start_page;
              this.searchRes.total_page = total_page;
            })
            .catch((error) => {
              console.log(error);
            });
        }
      } else {
        // 请求右边课程列表
        Api.getRightList(type, start_page)
          .then((res) => {
            const { count, list, start_page, total_page } = res.data;
            this.searchRes.count = count;
            this.searchRes.list = list;
            this.searchRes.start_page = parseInt(start_page);
            this.searchRes.total_page = total_page;
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
    showInternetList(start_page) {
      // 请求网络课程列表
      Api.getInternetRightList(start_page)
        .then((res) => {
          const { count, lessonList, start_page, total_page } = res.data;
          this.searchRes.count = count;
          this.searchRes.list = lessonList;
          this.searchRes.start_page = start_page;
          this.searchRes.total_page = total_page;
        })
        .catch((err) => console.log(err));
    },
    // 点击左边菜单栏
    handleMenuClick(id, name) {
      this.$router.push(`/${this.pathOne}/${id}`);
      this.searchRes.start_page = 1;
      store.commit("News/currentPage", 1);
      if (name === "网络课程") {
        this.showInternetList(1);
      } else if (name === "疫情防控宣传专栏") {
        return null;
      } else {
        this.showlist(id, 1);
      }
    },
    // 点击页数跳转
    currentPageClick(page) {
      // 存储当前页数
      store.commit("News/currentPage", page);
      if (this.contentTitle == "网络课程") {
        this.showInternetList(page);
        this.backTop();
      } else {
        this.showlist(this.pathTwo, page);
        this.backTop();
      }
    },
    // 点击右边文章列表进入文章
    handleGoContent(id, url) {
      if (url) {
        window.open(url);
      } else {
        if (this.pathOne == "online_service") {
          // 在线服务里面的特殊处理
          let { href } = this.$router.resolve({
            path: `/online_service/${this.pathTwo}/${id}`,
          });
          window.open(href, "_blank");
        } else {
          if (this.contentTitle == "网络课程") {
            let { href } = this.$router.resolve({
              path: `/old_age_education/${this.pathTwo}/${id}/${
                this.$store.state.News.currentPage
              }`,
            });
            window.open(href, "_blank");
          } else {
            let { href } = this.$router.resolve({
              path: `/${this.pathOne}/${this.pathTwo}/${id}`,
            });
            window.open(href, "_blank");
          }
        }
      }
    },
    // 刷新验证码
    handleRefreshCode() {
      this.authCode = Math.random();
      this.formData.code = "";
    },
    // 提交谏言献策
    handleSubmit() {
      if (
        this.formData.name &&
        this.formData.mobile &&
        this.formData.address &&
        this.formData.email &&
        this.formData.topic &&
        this.formData.content &&
        this.formData.employers &&
        this.formData.code
      ) {
        // 提交表单
        Api.addUserAdvice(this.formData)
          .then((res) => {
            if (res.code === 1) {
              alert("提交成功");
              this.formData = {};
            } else {
              alert(res.msg);
            }
          })
          .catch((err) => {
            console.log(err);
          });
      } else {
        return false;
      }
    },
    // 点击页数 返回顶部
    backTop() {
      document.documentElement.scrollTop = 0;
    },
    // 认证助手
    toggleCode() {
      const h = this.$createElement;
      this.$msgbox({
        title: "二维码",
        customClass: "school-box",
        message: h("span", null, [
          h("span", null, "扫码添加"),
          h("span", { style: "color: #C52E0F" }, " 认证助手 "),
          h("br"),
          h("span", null, "一对一专业指导"),
        ]),
      }).then((action) => {
        this.$message({
          type: "info",
          message: "action: " + action,
        });
      });
    },
    // 马上申请
    toggleRegisterCode() {
      const h = this.$createElement;
      this.$msgbox({
        title: "二维码",
        customClass: "register-box",
        message: h("span", null, [
          h("span", null, "扫码添加"),
          h("span", { style: "color: #C52E0F" }, " 官方客服 "),
          h("br"),
          h("span", null, "一对一专业指导"),
        ]),
      }).then((action) => {
        this.$message({
          type: "info",
          message: "action: " + action,
        });
      });
    },
    // 输入框聚焦显示文本限制
    focus(i) {
      this.aim = i;
    },
    // 智慧校园上传文件
    upload4(fileObj) {
      let fileTypeName = fileObj.file.name.split(".")[1];
      let fileSize = fileObj.file.size / 1024 / 1024;
      const fileTypeNameList = [
        "bmp",
        "jpg",
        "png",
        "hdri",
        "tif",
        "gif",
        "jpeg",
        "pcx",
        "tga",
        "exif",
        "fpx",
        "svg",
        "psd",
        "cdr",
        "pcd",
        "dxf",
        "ufo",
        "eps",
        "ai",
        "raw",
        "WMF",
        "webp",
      ];
      if (fileTypeNameList.includes(fileTypeName)) {
        if (fileSize > 6) {
          alert("请上传不超过6M的图片！");
        } else {
          this.uploadDesc = "正在上传...";
          let formData = new FormData();
          formData.append("file", fileObj.file);
          axios
            .post(`/index/uploadPicture`, formData, {
              headers: {
                "Content-type": "multipart/form-data",
              },
            })
            .then((res) => {
              this.uploadDesc = "上传";
              if (res.data.code === 1) {
                alert("上传成功！");
              } else {
                alert("上传失败，请重新上传！");
              }
            })
            .catch((err) => {
              this.uploadDesc = "上传";
              alert("上传失败，请重新上传！");
            });
        }
      } else {
        alert("请上传正确的图片格式！");
      }
    },
    getSmartSchoolWord() {
      Api.getSmartSchoolWord().then((res) => {
        this.downLoadUrl = res.data.url;
        this.downLoadName = res.data.name;
      });
    },
  },
  watch: {
    $route(to, from) {
      to.path != from.path ? this.getMenuLeftList(this.pathOne) : "";
    },
  },
  computed: {
    pathOne() {
      return this.$route.path.split("/")[1];
    },
    pathTwo() {
      return this.$route.path.split("/")[2];
    },
    imgSrc() {
      return `${process.env.baseURI}/index/captcha?${this.authCode}`;
    },
    pageTitle() {
      const title = {
        about: "关于我们",
        news: "新闻资讯",
        search: "站内搜索",
        old_age_education: "老年教育",
        lesson: "课程教材",
        teacher: "讲师精选",
        school: "校园活动",
        student: "学员风采",
        policy_building: "党政建设",
        special_report: "专题报导",
        information_open: "信息公开",
        online_service: "数字化校园",
        detail: "文章详情",
        info: {
          1: "",
          2: "关于我们",
          other: "新闻资讯",
        },
      };
      if (this.pathOne === "info") {
        return Object.keys(title.info).includes(this.pathTwo)
          ? title.info[this.pathTwo]
          : title.info.other;
      } else {
        return title[this.pathOne];
      }
    },
    contentTitle() {
      const noSubTitle = {
        lesson: "课程教材",
        teacher: "讲师精选",
        school: "校园活动",
        student: "学员风采",
      };
      if (Object.keys(noSubTitle).includes(this.pathOne)) {
        return noSubTitle[this.pathOne];
      } else {
        return store.getters["Home/getSubTitle"](this.pathOne, this.pathTwo);
      }
    },
    specialPage() {
      if (
        this.pathOne === "online_service" &&
        this.contentTitle === "数字化校园"
      ) {
        return "school";
      } else {
        const specialPage = {
          谏言献策: "advice",
          智慧管理系统申请: "register",
          疫情防控宣传专栏: "epidemic",
          智慧助老行动: "wisdom",
        };
        return Object.keys(specialPage).includes(this.contentTitle)
          ? specialPage[this.contentTitle]
          : "";
      }
    },
  },
  mounted() {
    this.uploadDesc = "上传";
    this.$router.push(`/${this.pathOne}/${this.pathTwo}`);
    this.getMenuLeftList(this.pathOne);
    this.getSmartSchoolWord();
  },
};
</script>
<style lang="scss" scoped>
%mgto {
  margin: 0 auto;
}
%ulst {
  margin: 0;
  padding: 0;
  list-style: none;
}

._activeli {
  color: #c52e0f !important;
  cursor: pointer !important;
}

@mixin displayflex($row, $column, $direction, $wrap) {
  display: flex;
  @if $direction == column {
    flex-direction: column;
  } @else {
    flex-direction: row;
  }
  @if $wrap == wrap {
    flex-wrap: wrap;
  } @else {
    flex-wrap: nowrap;
  }
  justify-content: $row;
  align-items: $column;
}
.box-border {
  box-sizing: border-box;
}
@mixin font-style($family, $size, $color, $weight) {
  font-family: $family;
  font-size: $size;
  color: $color;
  font-weight: $weight;
}

.newsframe {
  @extend %mgto;
  width: 1200px;
  @include displayflex(space-between, flex-start, row, nowrap);
  & > div:nth-child(1) {
    width: 250px;
  }
}

$pd-lf: padding-left;
.navlefttitle {
  background: url("../assets/newsnav_img1.png");
  background-size: 100% 100%;
  width: 100%;
  height: 80px;
  @include font-style(PingFangSC-Semibold, 24px, #ffffff, 600);
  @include displayflex(flex-start, center, row, nowrap);
  padding-left: 31px;
  box-sizing: border-box;
}
.newslist {
  @extend %ulst;
  margin-top: 10px;
  border-bottom: 4px solid #c52e0f;
  padding-bottom: 24px;
  width: 100%;
  background: #ffffff;
  li {
    width: 100%;
    height: 53px;
    @extend .box-border;
    #{$pd-lf}: 31px;
    @include displayflex(flex-start, center, row, nowrap);
    @include font-style(PingFangSC-Semibold, 18px, #3a3a3a, 600);
    border-bottom: 1px solid #dbdbdb;
    cursor: pointer !important;
    &:hover {
      color: #ffffff !important;
      background: #c52e0f !important;
    }
  }
}
.newscontent {
  width: 934px;
  height: 820px;
  background: #ffffff;
  margin-left: 17px;
  margin-bottom: 40px;
  @include displayflex(space-between, center, column, nowrap);
  @extend .box-border;
  padding: 0 40px;
  & > div:nth-child(1) {
    width: 100%;
    height: 100%;
    @include displayflex(flex-start, center, column, nowrap);
    & > nav {
      width: 100%;
      height: 73px;
      @include font-style(PingFangSC-Semibold, 20px, #c52e0f, 600);
      border-bottom: 2px solid #dbdbdb;
      @include displayflex(flex-end, flex-start, column, nowrap);
      & > span {
        padding-bottom: 15px;
        border-bottom: 2px solid #c52e0f;
        margin-bottom: -2px;
      }
    }
    & > ul {
      @extend %ulst;
      width: 100%;
      @include displayflex(flex-start, center, column, nowrap);
      box-sizing: border-box;
      & > li {
        width: 100%;
        line-height: 28px;
        padding-top: 14px;
        padding-bottom: 14px;
        @include displayflex(space-between, center, row, nowrap);
        border-bottom: 1px dashed #dbdbdb;
        cursor: pointer !important;
        .lesson-icon {
          width: 26px;
          height: 22px;
          margin-right: 14px;
          background-image: url("../assets/old_age_education/lesson-icon.png");
          background-size: 100% 100%;
        }
        .item-title {
          flex: 1;
          @include font-style(PingFangSC-Regular, 17px, #3a3a3a, 400);
          margin-right: 30px;
          &:hover {
            cursor: pointer !important;
            color: #c52e0f !important;
          }
        }
        .item-createtime {
          @include font-style(PingFangSC-Regular, 14px, #7a7a7a, 400);
        }
      }
    }
  }

  & > div:nth-child(2) {
    margin-bottom: 51px;
  }
}
.adviceContent {
  width: 934px;
  margin-left: 17px;
  margin-bottom: 40px;
  padding: 17px 40px 60px 40px;
  background: rgba(255, 255, 255, 1);
  box-sizing: border-box;
  header {
    height: 56px;
    @include font-style(PingFangSC-Semibold, 20px, rgba(197, 46, 15, 1), 600);
    line-height: 56px;
    margin-bottom: 60px;
    div {
      height: 2px;
      background-color: #dbdbdb;
      border-left: 80px solid #c52e0f;
    }
  }
  .form-box {
    letter-spacing: 0.5px;
    .inp-box {
      width: 100%;
      @include displayflex(flex-start, center, row, nowrap);
      height: 50px;
      margin-bottom: 20px;
      .inp-title {
        width: 123px;
        @include font-style(PingFangSC-Regular, 18px, rgba(58, 58, 58, 1), 400);
        line-height: 25px;
      }
      .inp-wrapper {
        flex: 1;
        input {
          width: 100%;
          padding: 0;
          padding-left: 20px;
          height: 50px;
          background: rgba(251, 251, 251, 1);
          box-sizing: border-box;
          border-radius: 4px;
          border: 1px solid rgba(233, 233, 233, 1);
          @include font-style(
            PingFangSC-Regular,
            18px,
            rgba(58, 58, 58, 1),
            400
          );
          line-height: 25px;
        }
      }
      .code-box {
        flex: 0 0 auto;
        width: 244px;
      }
      .img-wrapper {
        width: 120px;
        height: 50px;
        margin-left: 21px;
        margin-right: 20px;
        img {
          width: 100%;
          height: 50px;
          overflow: hidden;
        }
      }
      .font-wrapper {
        u {
          @include font-style(
            PingFangSC-Regular,
            18px,
            rgba(58, 58, 58, 1),
            400
          );
          line-height: 25px;
        }
        :hover {
          cursor: pointer !important;
        }
      }
    }
    .textarea-box {
      width: 100%;
      @include displayflex(flex-start, center, row, nowrap);
      // height: 100px;
      margin-bottom: 20px;
      .textarea-title {
        width: 123px;
        align-self: flex-start;
        @include font-style(PingFangSC-Regular, 18px, rgba(58, 58, 58, 1), 400);
        line-height: 25px;
      }
      .textarea-wrapper {
        flex: 1;
        position: relative;
        // height: 100%;
        textarea {
          resize: none;
          overflow-y: auto;
          width: 100%;
          padding: 13px 20px 18px 20px;
          height: 100px;
          background: rgba(251, 251, 251, 1);
          box-sizing: border-box;
          border-radius: 4px;
          border: 1px solid rgba(233, 233, 233, 1);
          @include font-style(
            PingFangSC-Regular,
            18px,
            rgba(58, 58, 58, 1),
            400
          );
          line-height: 25px;
        }
        .textarea1 {
          min-height: 100px;
        }
        .textarea2 {
          min-height: 200px;
        }
        .astrict-desc {
          position: absolute;
          right: 10px;
          bottom: 10px;
          // text-align: right;
          @include font-style(PingFangSC-Regular, 14px, #8f8e8e, 400);
        }
      }
    }
    .btn {
      margin-top: 40px;
      margin-left: 123px;
      box-sizing: border-box;
      width: 244px;
      height: 50px;
      background: rgba(197, 46, 15, 1);
      border-radius: 4px;
      @include font-style(
        PingFangSC-Regular,
        20px,
        rgba(255, 255, 255, 1),
        400
      );
      line-height: 50px;
      text-align: center;
    }
    .btn:hover {
      cursor: pointer !important;
    }
  }
}
// 智慧校园

.school {
  width: 934px;
  margin-left: 17px;
  margin-bottom: 40px;
  background-color: #fff;
  padding: 60px 80px 140px 80px;
  box-sizing: border-box;
  @include displayflex(center, center, column, nowrap);
  header {
    @include font-style(PingFangSC-Regular, 14px, #7a7a7a, 400);
    font-size: 24px;
    font-family: PingFangSC-Semibold;
    font-weight: 600;
    color: rgba(58, 58, 58, 1);
    line-height: 33px;
    text-align: center;
    margin-bottom: 30px;
  }
  section {
    width: 100%;
    @include font-style(PingFangSC-Regular, 18px, rgba(58, 58, 58, 1), 400);
    line-height: 30px;
    margin-bottom: 20px;
  }
  a {
    text-decoration: none;
  }
  a:link {
    text-decoration: none;
  }
  a:visited {
    text-decoration: none;
  }
  a:hover {
    text-decoration: none;
  }
  a:active {
    text-decoration: none;
  }
  .form-box {
    width: 100%;
    @include displayflex(flex-start, flex-start, column, nowrap);
    & > a {
      display: block;
      cursor: pointer;
      width: 100%;
      height: 66px;
      background: rgba(248, 248, 248, 1);
      border-radius: 4px;
      box-sizing: border-box;
      padding-left: 20px;
      padding-right: 20px;
      @include displayflex(space-between, center, row, nowrap);
      & > div:nth-child(1) {
        box-sizing: border-box;
        @include displayflex(flex-start, center, row, nowrap);
        & > div:nth-child(1) {
          width: 20px;
          height: 26px;
          margin-right: 14px;
          background-size: 100% 100%;
          background-image: url("../assets/online_service/word.png");
        }
        & > div:nth-child(2) {
          @include font-style(
            PingFangSC-Regular,
            16px,
            rgba(58, 58, 58, 1),
            400
          );
        }
      }
      & > div:nth-child(2) {
        box-sizing: border-box;
        @include displayflex(flex-start, center, row, nowrap);
        & > div:nth-child(1) {
          width: 24px;
          height: 22px;
          margin-right: 10px;
          background-size: 100% 100%;
          background-image: url("../assets/online_service/download-icon.png");
        }
        & > div:nth-child(2) {
          @include font-style(
            PingFangSC-Regular,
            16px,
            rgba(122, 122, 122, 1),
            400
          );
        }
      }
    }
    & > span {
      margin-top: 10px;
      @include font-style(
        PingFangSC-Regular,
        14px,
        rgba(136, 136, 136, 1),
        400
      );
      line-height: 20px;
    }
  }
  footer {
    margin-top: 60px;
    height: 50px;
    @include displayflex(center, center, row, nowrap);
    .school-btn {
      @include displayflex(center, center, row, nowrap);
      width: 180px;
      height: 50px;
      margin-left: 40px;
      border-radius: 4px;
      border: 1px solid rgba(197, 46, 15, 1);
      box-sizing: border-box;
      @include font-style(PingFangSC-Regular, 20px, rgba(197, 46, 15, 1), 400);
      cursor: pointer;
    }
  }
  .school-code-box {
    margin-top: 60px;
    width: 286px;
    height: 346px;
    border-radius: 4px;
    border: 1px solid rgba(233, 233, 233, 1);
    box-sizing: border-box;
    @include displayflex(flex-start, center, column, nowrap);
    @include font-style(PingFangSC-Regular, 18px, rgba(36, 36, 36, 1), 400);
    line-height: 24px;
    & > div:nth-child(1) {
      margin-top: 14px;
      width: 252px;
      height: 252px;
      background-image: url("../assets/online_service/code.png");
      background-size: 100% 100%;
    }
    & > div:nth-child(2) {
      margin-top: 10px;
      & > span {
        color: #c52e0f;
      }
    }
  }
}
.register {
  width: 934px;
  margin-left: 17px;
  margin-bottom: 40px;
  background-color: #fff;
  padding: 60px 80px 140px 80px;
  box-sizing: border-box;
  @include displayflex(center, center, column, nowrap);
  header {
    @include font-style(PingFangSC-Regular, 14px, #7a7a7a, 400);
    font-size: 24px;
    font-family: PingFangSC-Semibold;
    font-weight: 600;
    color: rgba(58, 58, 58, 1);
    line-height: 33px;
    text-align: center;
    margin-bottom: 30px;
  }
  & > div {
    @include font-style(PingFangSC-Regular, 18px, rgba(58, 58, 58, 1), 400);
    line-height: 30px;
    margin-bottom: 30px;
    width: 100%;
    & > span {
      font-weight: 600;
    }
  }
  footer {
    margin-top: 50px;
    width: 180px;
    height: 50px;
    background: rgba(197, 46, 15, 1);
    border-radius: 4px;
    line-height: 50px;
    text-align: center;
    @include font-style(PingFangSC-Regular, 20px, rgba(255, 255, 255, 1), 400);
  }
  footer:hover {
    cursor: pointer !important;
  }
}
</style>
<style lang="scss">
@mixin font-style($family, $size, $color, $weight) {
  font-family: $family;
  font-size: $size;
  color: $color;
  font-weight: $weight;
}
@mixin displayflex($row, $column, $direction, $wrap) {
  display: flex;
  @if $direction == column {
    flex-direction: column;
  } @else {
    flex-direction: row;
  }
  @if $wrap == wrap {
    flex-wrap: wrap;
  } @else {
    flex-wrap: nowrap;
  }
  justify-content: $row;
  align-items: $column;
}
.upload-btn {
  width: 180px;
  height: 50px;
  background: rgba(197, 46, 15, 1);
  border-radius: 4px;
  @include displayflex(center, center, column, nowrap);
  @include font-style(PingFangSC-Regular, 20px, rgba(255, 255, 255, 1), 400);
}
.search-footer {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 40px;
  margin-top: 32px;
}
.school-box {
  width: 352px !important;
  height: 403px !important;
  background: rgba(255, 255, 255, 1);
  border-radius: 10px !important;
  overflow: inherit !important;
  padding: 45px 50px !important;
  box-sizing: border-box !important;
  .el-message-box__header {
    padding: 0 !important;
    .el-message-box__title {
      font-size: 0 !important;
      width: 252px !important;
      height: 252px !important;
      background-image: url("../assets/online_service/code.png") !important;
      background-size: 100% 100% !important;
    }
    .el-message-box__headerbtn {
      width: 24px !important;
      height: 24px !important;
      font-size: 24px !important;
      top: -69px !important;
      right: -84px !important;
      i {
        color: #fff !important;
      }
    }
  }
  .el-message-box__content {
    .el-message-box__message {
      display: flex !important;
      & > span {
        width: 268px !important;
        font-size: 18px !important;
        font-family: PingFangSC-Regular !important;
        font-weight: 400 !important;
        color: rgba(36, 36, 36, 1) !important;
        line-height: 24px !important;
        text-align: center !important;
      }
    }
  }
  .el-message-box__btns {
    display: none !important;
  }
}
.register-box {
  width: 352px !important;
  height: 403px !important;
  background: rgba(255, 255, 255, 1);
  border-radius: 10px !important;
  overflow: inherit !important;
  padding: 45px 50px !important;
  box-sizing: border-box !important;
  .el-message-box__header {
    padding: 0 !important;
    .el-message-box__title {
      font-size: 0 !important;
      width: 252px !important;
      height: 252px !important;
      background-image: url("../assets/online_service/register-code.png") !important;
      background-size: 100% 100% !important;
    }
    .el-message-box__headerbtn {
      width: 24px !important;
      height: 24px !important;
      font-size: 24px !important;
      top: -69px !important;
      right: -84px !important;
      i {
        color: #fff !important;
      }
    }
  }
  .el-message-box__content {
    .el-message-box__message {
      display: flex !important;
      & > span {
        width: 268px !important;
        font-size: 18px !important;
        font-family: PingFangSC-Regular !important;
        font-weight: 400 !important;
        color: rgba(36, 36, 36, 1) !important;
        line-height: 24px !important;
        text-align: center !important;
      }
    }
  }
  .el-message-box__btns {
    display: none !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/NewsMenu.vue